import { useInView } from 'react-intersection-observer';

import * as s from './styles/iframe.module.scss';

import { generateClassName } from '@klv/shared/utils/functions';

import type { IIframeProps } from './types';


const Iframe = ({
  backgroundColor = 'light',
  className,
  forceRender = false,
  heightType = 'medium',
  title,
  url,
  ...props
}: IIframeProps) => {
  const { ref, inView } = useInView({ threshold: .25 });

  return (
    <section
      {...props}
      className={generateClassName([s.iframeModule, s[backgroundColor], className])}
      ref={ref}
    >
      <div className={generateClassName(['grid', s.grid])}>
        {(inView || forceRender) && (
          <iframe
            className={generateClassName([s.iframe, s[heightType]])}
            title={title}
            src={url}
          />)
        }
      </div>
    </section>
  );
};

export default Iframe;
